import { useAuth0 } from '@auth0/auth0-react';
import { useApi } from '../hooks/useApi';

export default function AuthenticationGuard({ children }) {
  const { isLoading, isAuthenticated, error, loginWithRedirect } = useAuth0();

  // Initialize API service with auth token
  useApi();

  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #070a0d 0%, #0c1117 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '64px',
            height: '64px',
            border: '4px solid rgba(0, 212, 255, 0.2)',
            borderTop: '4px solid #00d4ff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div style={{ color: '#e6f0ff', fontSize: '20px', fontWeight: '500' }}>Loading...</div>
          <div style={{ color: '#5a7090', fontSize: '14px', marginTop: '8px' }}>Authenticating with Auth0</div>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #070a0d 0%, #0c1117 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          background: 'rgba(220, 38, 38, 0.1)',
          border: '1px solid #dc2626',
          borderRadius: '12px',
          padding: '32px',
          maxWidth: '448px'
        }}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#fca5a5', marginBottom: '12px' }}>
            Authentication Error
          </h2>
          <p style={{ color: '#e5e7eb', marginBottom: '16px' }}>{error.message}</p>
          <button
            onClick={() => loginWithRedirect()}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: '#00d4ff',
              color: '#070a0d',
              fontWeight: 'bold',
              width: '100%',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #070a0d 0%, #0c1117 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          background: 'rgba(12, 17, 23, 0.8)',
          border: '1px solid #00d4ff',
          borderRadius: '12px',
          padding: '32px',
          maxWidth: '448px',
          backdropFilter: 'blur(8px)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: '#00d4ff',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px'
            }}>
              <img
                src="/tomahawk-icon.svg"
                alt="TMPC Logo"
                style={{
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          </div>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#e6f0ff', marginBottom: '8px', textAlign: 'center' }}>
            TMPC NextGen
          </h2>
          <p style={{ color: '#00d4ff', textAlign: 'center', marginBottom: '24px' }}>
            AI-Enhanced Mission Planning System
          </p>
          <p style={{ color: '#e5e7eb', marginBottom: '24px', textAlign: 'center' }}>
            This application requires authentication to access mission planning capabilities.
          </p>
          <button
            onClick={() => loginWithRedirect()}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: '#00d4ff',
              color: '#070a0d',
              fontWeight: 'bold',
              width: '100%',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Login to Continue
          </button>
          <p style={{ fontSize: '12px', color: '#5a7090', marginTop: '16px', textAlign: 'center' }}>
            UNCLASSIFIED // FOR DEMONSTRATION ONLY
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
